<template>
  <div class="box">
    <Card title="提醒">
      <Spin fix v-if="showPageLoading"></Spin>
      <!-- <Divider style="margin-top:10px;" orientation="left">查询条件
        <span @click="queryShow = true" v-if="!queryShow">（点击展开）</span>
        <span @click="queryShow = false" v-else>（点击收起）</span>
      </Divider>
      <Form ref="formValidate" v-show="queryShow" :label-width="0" :model="queryForm" inline>
        <FormItem>
          <Input v-model.trim="queryForm.name" placeholder="请输入姓名" style="width:42vw"></Input>
        </FormItem>
        <FormItem>
          <Input v-model.trim="queryForm.identityNumber" placeholder="请输入身份证号码" style="width:42vw"></Input>
        </FormItem>
        <FormItem>
          <Input v-model.trim="queryForm.enterpriseName" placeholder="请输入单位名称" style="width:42vw"></Input>
        </FormItem>
        <FormItem>
          <Button size="small" shape="circle" icon="md-refresh" style="margin-left:10px; " @click="reset('formCl')"></Button>
          <Button size="small" shape="circle" icon="md-search" style="margin-left:10px; " type="primary" @click="queryTable('formCl')"></Button>
        </FormItem>
      </Form> -->
      <div class="cardList">
        <div class="card_box" v-for="(item,index) in data" :key="index">
          <div class="card_title">
            <span>办文单号：</span> {{item.documentNumber}}
          </div>
          <div class="card_title">
            <span>预审人员：</span>{{item.distributionUserName}}
          </div>
          <div class="card_title">
            <span>姓名：</span>{{item.name}}
          </div>
          <div class="card_title">
            <span>身份证号码：</span>{{item.identityNumber}}
          </div>
          <div class="card_title">
            <span>网点：</span>{{item.serviceBranch}}
          </div>
          <div class="card_title">
            <span>申报单位：</span>{{item.enterpriseName}}
          </div>
          <div class="card_title">
            <span>上报时间：</span> {{item.reportTimeText}}
          </div>
          <div class="card_title">
            <span>指派状态：</span> {{item.distributionStatusText}}
          </div>
          <div class="card_title">
            <span>状态：</span> {{item.statusText}}
          </div>
        </div>
        <div class="ddl" v-if="page.total == data.length">到底了</div>
      </div>
    </Card>
  </div>

</template>
<script>
import '../residencePermitIntegral/styles/points.less'
export default {
  data() {
    return {
      data: [],
      queryShow: true,
      queryForm: {
        applicationNo: '',
        enterpriseName: '',
        applicantName: '',
        applicantIDCardNo: '',
        enterpriseId: null,
        enterpriseAgentId: null,
        status: null,
        documentNumber: null,
        preliminaryDistributionUserIds: [],
        preliminaryDistributionOrgId: null,
        applicationType: null,
        startReportTime: null,
        endReportTime: null,
        serviceBranch: null,
        distributionStatus: 3,
        time: [],

        // query_落户业务受理初审: true,
        query_派单: true,
      }, //查询参数
      page: {
        //分页参数
        total: 0,
        current: 0,
        skipCount: 0,
        maxResultCount: 10,
      },
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
      appHouseholdTypeList: [],
      serviceBranchList: [],
      statusList: [],
      orgAndUsersList: [],
      orgList: [],
      showPageLoading: false,
      m: '',
      guid: '',
    }
  },
  created() {
    // if (this.$route.name.includes('householdJZHEnd')) {
    //   this.queryForm.applicationType = this.$store.state.LHApplicationType.居转户落户
    // } else if (this.$route.name.includes('householdRCYJEnd')) {
    //   this.queryForm.applicationType = this.$store.state.LHApplicationType.人才引进落户
    // } else if (this.$route.name.includes('householdLXSEnd')) {
    //   this.queryForm.applicationType = this.$store.state.LHApplicationType.留学生落户
    // } else {
    //   this.queryForm.applicationType = this.$store.state.LHApplicationType.解困落户
    // }
  },
  mounted() {
    this.m = this.$route.query.m
    this.guid = this.$route.query.guid
    this.getTable()
    this.setupScrollListener()
    // this.getSelectList()
  },
  methods: {
    async getSelectList() {
      let { data } = await this.$Ajax.post('/api/services/app/RCLHMgrApi/GetLHMgrBasicData', {
        query_受理确认: false,
        query_受理确认待流转: false,
        query_一审待审核查询: false,
        query_一审待流转查询: false,
        query_二审待审核查询: false,
        query_二审待流转查询: false,
        query_三审待审核查询: false,
      })
      if (data.success) {
        this.appHouseholdTypeList = data.result.lhApplicationTypeList
        this.distributionStatusList = data.result.distributionStatusList
        this.serviceBranchList = data.result.serviceBranchList
        this.statusList = data.result.statusList
        this.orgAndUsersList = data.result.orgAndUsersList
        this.orgList = data.result.orgList
      }
    },

    timeChange(e) {
      console.log('🚀 ~ timeChange ~ e:', e)
      let start = e[0]
      let end = e[1]
      this.queryForm.startReportTime = start
      this.queryForm.endReportTime = end
    },
    setupScrollListener(event) {
      let _this = this
      const cardListBody = document.querySelector('.box')

      // 监听 cardListBody 的 scroll 事件
      cardListBody.addEventListener('scroll', () => {
        const { scrollTop, scrollHeight, clientHeight } = cardListBody
        if (scrollTop + clientHeight >= scrollHeight) {
          console.log('滚动到底部了！')
          if (_this.page.total > _this.data.length) {
            _this.page.current++
            _this.page.skipCount = _this.page.maxResultCount * _this.page.current
            _this.getTable()
          }
          // 执行你想要的操作
        }
      })
    },
    queryTable() {
      this.data = []
      this.page = {
        //分页参数
        total: 0,
        current: 0,
        skipCount: 0,
        maxResultCount: 10,
      }
      this.getTable()
    },
    async getTable() {
      let _this = this
      this.loading = true
      let params = { ...this.queryForm, ...this.page }
      let { data } = await this.$Ajax.get('/api/services/app/JZZJF/GetRemindAppList', {
        params: { guid: this.guid, m: this.m },
      })
      if (data.success) {
        // this.page.total = data.result.totalCount
        // this.data = data.result.items
        data.result.forEach((el) => {
          _this.data.push(el)
        })
      }
      this.loading = false
    },
    reset(val) {
      this.data = []
      this.queryForm = {
        applicationNo: '',
        enterpriseName: '',
        applicantName: '',
        applicantIDCardNo: '',
        enterpriseId: null,
        enterpriseAgentId: null,
        status: null,
        documentNumber: null,
        preliminaryDistributionUserIds: [],
        preliminaryDistributionOrgId: null,
        applicationType: null,
        startReportTime: null,
        endReportTime: null,
        serviceBranch: null,
        query_派单: true,
        distributionStatus: 3,

        time: [],
      } //查询参数
      this.page = {
        //分页参数
        total: 0,
        current: 0,
        skipCount: 0,
        maxResultCount: 10,
      }
      this.getTable()
    },
  },
}
</script>
<style lang="less" scoped>
.box {
  max-height: 100vh;
  overflow: auto;
}
/deep/.ivu-card-body {
  min-height: 100vh;
}
/deep/.archive.ivu-alert {
  padding: 8px 8px 8px 15px;
}
.card_box {
  padding: 10px 10px 0 10px;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  margin-bottom: 10px;
  box-shadow: #e8eaec 2px 2px 4px;
  .card_title {
    margin-bottom: 10px;
    span {
      display: inline-block;
      width: 100px;
      font-weight: 600;
    }
  }
}
// .card_title span::before {
//   content: '';
//   display: inline-block;
//   width: 3px;
//   height: 16px;
//   background: #3c9dff;
//   margin-right: 5px;
//   border-radius: 5px;
//   position: relative;
//   top: 2px;
// }
.ddl {
  text-align: center;
}
</style>